import { render, staticRenderFns } from "./appsview.vue?vue&type=template&id=19a7a358&scoped=true&"
import script from "./appsview.vue?vue&type=script&lang=js&"
export * from "./appsview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7a358",
  null
  
)

export default component.exports